import React from 'react';
import { trainingPrograms } from '../data/mock';
import { Clock, TrendingUp, BookOpen, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const TrainingPrograms = () => {
  const navigate = useNavigate();

  return (
    <section id="programs" style={{ background: 'var(--bg-primary)', padding: '100px 7.6923%', borderTop: '1px solid var(--border-subtle)' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        
        {/* SEO Optimized Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2 className="display-large" style={{ marginBottom: '20px' }}>
            IT Professional Certifications & Training Programs
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
            Industrial certification tracks in Cybersecurity, Ethical Hacking, Python, and AIML designed by active engineers to secure placements at our parent company or top IT hubs.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '40px' }}>
          {trainingPrograms.map((program) => (
            <div key={program.id} style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-subtle)', overflow: 'hidden', transition: 'all 0.4s ease-in-out' }} className="dark-hover">
              
              {/* Program Image & Semantic Meta Alt Tag mapping */}
              <div style={{ width: '100%', height: '200px', overflow: 'hidden', position: 'relative' }}>
                <img 
                  src={program.image} 
                  alt={program.altText || program.title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s ease-in-out' }}
                  onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                  onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, transparent, rgba(0,0,0,0.7))' }} />
              </div>

              <div style={{ padding: '40px' }}>
                <div style={{ marginBottom: '24px' }}>
                  <h3 className="heading-1" style={{ marginBottom: '16px', color: 'var(--brand-primary)' }}>{program.title}</h3>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                    <Clock size={18} style={{ color: 'var(--text-muted)' }} />
                    <span className="body-small" style={{ color: 'var(--text-muted)' }}>{program.duration} Track</span>
                  </div>
                  <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>{program.description}</p>
                </div>

                {/* Key Skills Section */}
                <div style={{ marginBottom: '24px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                    <BookOpen size={20} style={{ color: 'var(--brand-primary)' }} />
                    <h4 className="heading-3">Key Lab Skills</h4>
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {program.skills.slice(0, 4).map((skill, index) => (
                      <span key={index} style={{ background: 'rgba(0, 255, 209, 0.1)', border: '1px solid var(--brand-primary)', padding: '6px 12px', fontSize: '14px', color: 'var(--text-secondary)' }}>
                        {skill}
                      </span>
                    ))}
                    {program.skills.length > 4 && (
                      <span style={{ background: 'rgba(0, 255, 209, 0.1)', border: '1px solid var(--brand-primary)', padding: '6px 12px', fontSize: '14px', color: 'var(--text-secondary)' }}>
                        +{program.skills.length - 4} more
                      </span>
                    )}
                  </div>
                </div>

                {/* Career Paths Section */}
                <div style={{ marginBottom: '24px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                    <TrendingUp size={20} style={{ color: 'var(--brand-primary)' }} />
                    <h4 className="heading-3">Target Industry Roles</h4>
                  </div>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {program.careers.slice(0, 3).map((career, index) => (
                      <li key={index} className="body-medium" style={{ color: 'var(--text-secondary)', marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                        <span style={{ position: 'absolute', left: 0, color: 'var(--brand-primary)' }}>→</span>
                        {career}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Dynamic Slug Routing Handler */}
                <Button 
                  className="btn-primary" 
                  style={{ width: '100%' }}
                  onClick={() => navigate(`/programs/${program.slug}`)}
                >
                  View Full Course Syllabus
                  <ArrowRight size={20} />
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrainingPrograms;